/* LAZERPOP — petits comportements globaux : upsell du panier, copie du code de bienvenue */
(function(){
  document.addEventListener('click',function(e){
    var c=e.target.closest('[data-lp-copy]');
    if(c){ try{navigator.clipboard.writeText(c.dataset.lpCopy)}catch(x){} c.textContent=c.dataset.done||'OK'; return; }
    var u=e.target.closest('[data-lp-up]'); if(!u)return;
    e.preventDefault(); u.disabled=true;
    var root=(window.LP&&LP.root)||'/';
    var onCartPage=!!document.querySelector('cart-items:not(cart-drawer-items)')&&!document.querySelector('cart-drawer.active');
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+u.dataset.lpUp,quantity:1}],sections:'cart-drawer,cart-icon-bubble'})})
      .then(function(r){return r.json()}).then(function(j){
        var d=document.querySelector('cart-drawer');
        if(!onCartPage&&d&&d.renderContents&&j.sections){d.renderContents({id:+u.dataset.lpUp,sections:j.sections});}
        else location.reload();
      }).catch(function(){location.reload()});
  });
})();
